import { Button, Image, Space, Table, Tag } from "antd";
import { getLocationImage, getLocationImageUrl } from './locationImage';
import Loading from 'layouts/Loading/Loading';
import Axios from 'middleware/axiosInstance';
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

function LocationGallery() {
  const navigate = useNavigate();

  const [allLocations, setAllLocations] = useState(null)
  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});

  const getAllLocations = () => {
    Axios.get("/location-gallery")
      .then((res) => {
        // Filter to show only locations with images
        const locationsWithImages = res.data.filter(location => getLocationImage(location));
        setAllLocations(locationsWithImages)
      })
      .catch(err => console.log(err))
  }

  useEffect(() => {
    getAllLocations()
  }, []);

  const clearFilters = () => {
    setFilteredInfo({});
  };

  const clearAll = () => {
    setFilteredInfo({});
    setSortedInfo({});
  };

  const handleChange = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };

  const deleteDoc = (location) => {
    if (window.confirm(`آیا شعبه  "${location.name_fa}" حذف گردد؟`)) {
      deleteDocHandler(location);
    }
  };

  const deleteDocHandler = (location) => {
    Axios.delete(`location/${location.id}`)
      .then((res) => {
        if (res.status === 204) {
          console.log(res);
        }
        getAllLocations()
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
      });
  };

  const goToAddPage = () => {
    navigate("/locations/add")
  }

  const columns = [
    {
      title: "تصویر",
      dataIndex: "image",
      key: "image",
      width: 100,
      render: (image, record) => (
        getLocationImage(record) ? (
          <Image
            width={60}
            height={60}
            src={getLocationImageUrl(record)}
            alt={record.name_fa}
            style={{ objectFit: 'cover', borderRadius: '4px' }}
            preview={false}
          />
        ) : (
          <span>-</span>
        )
      ),
    },
    {
      title: "نام فارسی",
      dataIndex: "name_fa",
      key: "name_fa",
      sorter: (a, b) =>
        a.name_fa > b.name_fa ? 1 : b.name_fa > a.name_fa ? -1 : 0,
      sortOrder: sortedInfo.columnKey === "name_fa" ? sortedInfo.order : null,
      ellipsis: true,
      render: (text, record) => (
        <Space>
          <span>{text}</span>
          {record['is_Central_office'] && (
            <Tag color="gold">مرکزی</Tag>
          )}
        </Space>
      ),
    },
    {
      title: "نام انگلیسی",
      dataIndex: "name_en",
      key: "name_en",
      sorter: (a, b) =>
        a.name_en > b.name_en ? 1 : b.name_en > a.name_en ? -1 : 0,
      sortOrder: sortedInfo.columnKey === "name_en" ? sortedInfo.order : null,
      ellipsis: true,
    },
    {
      title: "نام عربی",
      dataIndex: "name_ar",
      key: "name_ar",
      ellipsis: true,
    },
    {
      title: "عملیات",
      dataIndex: "action",
      key: "action",
      render: (a, location) => (
        <Space size="small">
          <Link
            to={`/locations/edit/${location.id}`}
            className="btn btn-primary btn-sm"
          >ویرایش</Link>
          <button
            onClick={() => deleteDoc(location)}
            className="btn btn-danger btn-sm"
          >حذف</button>
        </Space>
      ),
    },
  ];

  return (
    <div className="customized-container">
      <div className="customized-wrapper">
        <Space
          style={{
            marginBottom: 16,
          }}
        >
          <Button onClick={goToAddPage}>اضافه کردن</Button>
          <Button onClick={clearFilters}>حذف فیلترها</Button>
          <Button onClick={clearAll}>حذف فیلتر و مرتب ها</Button>
        </Space>
        <div>
          {allLocations ?
            allLocations[0] ?
              <Table
                pagination={false}
                columns={columns}
                dataSource={allLocations}
                rowKey="id"
                onChange={handleChange}
              />
              : <h2>محتوایی نیست</h2> : <Loading />}
        </div>
      </div>
    </div>
  );
}

export default LocationGallery;
